module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1MDUiIHZpZXdCb3g9IjAgMCAxNDQwIDUwNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0wIDUwLjk3MTdDMCA1MC45NzE3IDQxOS40NTcgMi4yNTM3IDcwMi41IDAuMDcxNTQwNEM5OTguODA4IC0yLjIxMjkgMTQ0MCA1MC45NzE3IDE0NDAgNTAuOTcxN1Y1MDVIMFY1MC45NzE3WiIgZmlsbD0iIzQ2NTE2QiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_bottom.svg
// module id = D0dG
// module chunks = 1